/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Italic({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M9.01 1.4H12a.6.6 0 1 1 0 1.2H9.508l-1.8 10.8H10a.6.6 0 1 1 0 1.2H7.011a.74.74 0 0 1-.02 0H4a.6.6 0 1 1 0-1.2h2.492l1.8-10.8H6a.6.6 0 0 1 0-1.2h3.01Z" /></svg>;
}
;